import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { Form, useTranslate } from 'react-admin';
import ModalInput from './ModalInput';

interface QrCodeLogoInputModalProps {
  showDialog: boolean,
  handleCloseClick: () => void,
  source?: string,
  defaultValue?: string,
}

const QrCodeLogoInputModal = ({ source, showDialog, handleCloseClick, defaultValue }: QrCodeLogoInputModalProps) => {
  const translate = useTranslate();
  return (
    <Dialog
      maxWidth={"xl"}
      fullWidth
      open={showDialog}
      onClose={handleCloseClick}
      aria-label={"ra.action.qr_code_generator"}
    >
      <DialogTitle>{translate('ra.action.qr_code_generator')}</DialogTitle>
      {source ? <ModalInput source={source} defaultValue={defaultValue} /> : <Form><ModalInput source={'temp'} defaultValue={defaultValue} /></Form>}
    </Dialog>
  )
}

QrCodeLogoInputModal.defaultProps = {
  label: 'ra.action.qr_code_generator',
}

export default QrCodeLogoInputModal;
